module.exports = __webpack_public_path__ + "img/rightthigh-endo-mesomorph-female.cd9e17a9.svg";